import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import StoreLocatorDropdown from "./storeLocatorDropdown";
import { StoreLocatorContext } from "@/routes/storeLocator/storeLocator";

const StoreLocatorHeaderMob = () => {
  const [showDropDown, setShowDropDown] = useState(false);

  const { t } = useTranslation("storeLocator");

  const {
    handleCurrentLocation,
    selectedCountry,
    selectedShop,
    handleChangeSelectedShop
  } = useContext(StoreLocatorContext);

  const handleShowDropdown = () => setShowDropDown(prev => !prev);

  const handleSelectedShop = selectedShop => {
    handleChangeSelectedShop({ shopItem: selectedShop });
    handleShowDropdown();
  };

  return (
    <>
      <div className="store-header-conatiner">
        <div className="current-locator-wrapper-mobile">
          <p className="info">{t("locateStore")}</p>
          <span className="current-loc-icon" onClick={handleCurrentLocation} />
        </div>
        <div className="store-header-wrapper">
          <h2 className="store-locator-heading">{t("storeHeader")}</h2>
          <div className="store-locator-dropdown-box-wrapper">
            <div
              className="store-locator-dropdown-box"
              onClick={handleShowDropdown}
            >
              <div className="inner-content">
                <span className="mainSelected">
                  {`${selectedShop.countryName || ""} ${
                    selectedShop.countryName ? "," : ""
                  }${selectedShop.name || ""}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showDropDown ? (
        <div
          className={`storelocator_dropdown_mob ${
            showDropDown
              ? "storelocator_dropdown_active"
              : "storelocator_dropdown_inactive"
          }`}
        >
          <StoreLocatorDropdown
            selectedShop={selectedShop}
            backClick={handleShowDropdown}
            selectedCountry={selectedCountry}
            handleSelectedShop={handleSelectedShop}
          />
        </div>
      ) : null}
    </>
  );
};

export default StoreLocatorHeaderMob;
